export default function initVideoplayers() {
  document.querySelectorAll('.video-container').forEach((container) => {
    const video = container.querySelector('video');
    const toggle = container.querySelector('.video-overlay');

    if (!video || !toggle) return;

    const sync = () => {
      container.classList.toggle('is-playing', !video.paused && !video.ended);
    };

    toggle.addEventListener('click', (e) => {
      e.preventDefault();

      // Mobile browsers keep :hover "stuck" on the tapped element until
      // something else is focused. Blurring right away avoids the pause
      // icon getting stuck visible after a single tap.
      toggle.blur();

      if (video.paused || video.ended) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });

    // Reflect the video's actual state rather than assuming it from the
    // click alone, so autoplay, buffering, or the browser pausing the
    // video (e.g. when it scrolls out of view) never desync the icon.
    video.addEventListener('play', sync);
    video.addEventListener('pause', sync);
    video.addEventListener('ended', sync);

    sync();
  });
}
